import React from "react";

class DataCollectionBG extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="139.031"
        height="109.562"
        viewBox="0 0 139.031 109.562"
      >
        <path
          id="#tariffsSlideUchetBg"
          className="cls-1"
          d="M406,376c13.481-17.617,106.985-18.21,124-1,15.05,15.222-.48,59.379-29,79-33.091,22.766-68.268,22.211-87,8C396.733,448.9,389.8,397.169,406,376Z"
          transform="translate(-396.844 -362.438)"
          fill="currentColor"
        />
        <text
          y="50"
          transform="translate(64)"
          fill="currentColor"
          fontFamily="sans-serif"
          fontSize="15"
        >
          <tspan x="0" textAnchor="middle">
            «Учет»
          </tspan>
          <tspan
            x="0"
            textAnchor="middle"
            dy="15"
            id="tarrifsSlideTariffPrice"
          >
            980 руб/месяц
          </tspan>
        </text>
      </svg>
    );
  }
}

export default DataCollectionBG;
